module.exports = __webpack_public_path__ + "static/media/file.c121f6d3.svg";